
    import { Component, Vue } from 'vue-property-decorator';
    import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";

    @Component({
        components:{       
            LegalAssistanceFaq
        }
    })
    export default class LegalAssistanceFaqDropdown extends Vue {
        showLegalAssistance = false;
    }
